import * as Sentry from '@sentry/nextjs';
import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_ERROR_SAMPLE_RATE,
  SENTRY_REPLAY_SAMPLE_RATE,
  SENTRY_TRACE_SAMPLE_RATE,
} from '@/lib/config';
import { getRuntimeClientEnvironment } from '@/lib/environment';

const clientIntegrations: SentryBrowserIntegrations = [
  Sentry.replayIntegration({
    maskAllText: true,
    blockAllMedia: true,
  }),
  Sentry.browserTracingIntegration(),
  Sentry.extraErrorDataIntegration(),
  Sentry.consoleLoggingIntegration({ levels: ['info', 'warn', 'error'] }),
];

const clientConfig: SentryBrowserOptions = {
  debug: false,
  dsn: SENTRY_ENVIRONMENT ? SENTRY_DSN : '',
  environment: SENTRY_ENVIRONMENT,
  integrations: clientIntegrations,
  replaysSessionSampleRate: SENTRY_REPLAY_SAMPLE_RATE,
  replaysOnErrorSampleRate: SENTRY_ERROR_SAMPLE_RATE,
  sendDefaultPii: true,
  tracesSampleRate: SENTRY_TRACE_SAMPLE_RATE,
  enableLogs: true,
};

const initSentry = async () => {
  const environment = await getRuntimeClientEnvironment();

  if (!['local', 'test'].includes(environment)) {
    Sentry.init({ ...clientConfig, environment });
  }
};

void initSentry();

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
